// src/components/auth/PublicRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router";
import { useAuthContext } from "contexts";
import PublicLayout from "./layout/PublicLayout";
import PageSuspense from "./PageSuspense";

const PublicRoute = () => {
  const { isAuthenticated } = useAuthContext();

  if (isAuthenticated) {
    // already logged in → redirect to dashboard (or home)
    return <Navigate to="/home" replace />;
  }

  return (
    <PublicLayout>
      <PageSuspense><Outlet /></PageSuspense>
    </PublicLayout>
  );
};

export default PublicRoute;
